const FaqCategory = () =>
  import(
    /* webpackChunkName: "site-generator-faq-category" */ '@/pages/site-generator/base-info/faq-category/index.vue'
  )
const CreateFaqCategory = () =>
  import(
    /* webpackChunkName: "site-generator-faq-category" */ '@/pages/site-generator/base-info/faq-category/create.vue'
  )
const EditFaqCategory = () =>
  import(
    /* webpackChunkName: "site-generator-faq-category" */ '@/pages/site-generator/base-info/faq-category/edit.vue'
  )

export default {
  path: 'faq-category',
  meta: {
    label: 'faqCategory',
    auth: 'faqCategory'
  },
  component: {
    name: 'FaqCategory',
    render(c) {
      return c('router-view')
    }
  },
  children: [
    {
      name: 'SiteFaqCategoryReport',
      path: '',
      meta: {
        label: 'report',
        auth: 'report'
      },
      component: FaqCategory
    },
    {
      name: 'SiteCreateFaqCategory',
      path: 'create',
      meta: {
        label: 'create',
        auth: 'create'
      },
      component: CreateFaqCategory
    },
    {
      name: 'SiteEditFaqCategory',
      path: 'edit/:id',
      meta: {
        label: 'edit',
        auth: 'update'
      },
      component: EditFaqCategory,
      props: true
    }
  ]
}
